export default function interpolateUrl(url, params) {
	return url.replace(
		/(^|\/):(\w+)(?=\/|\?|$)/g,
		(m, g1, g2) => g1 + (params[g2] || m)
	);
}
